<template>
  <div class="store_wrapper">
    <main v-if="branches && branches.length > 0">
      <v-data-table
        class="thumb strip"
        :headers="headers"
        :items="branches"
        :custom-filter="helper_filterSearch"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        hide-default-footer
        :items-per-page="branches.length"
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Image -->
        <template v-slot:[`item.avatar`]="{ item }">
          <div v-if="item.icon">
            <img
              class="image"
              :src="item.images[0]?.image"
              @click="show_model_1"
            />
          </div>
        </template>

        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>
        <template v-slot:[`item.is_have_meals`]="{ item }">
          <v-chip :color="item.is_have_meals ? 'success' : 'error'">
            {{ item.is_have_meals ? "نعم" : "لا" }}
          </v-chip>
        </template>
        <template v-slot:[`item.location`]="{ item }">
          <div>
            <span></span>
            <button class="btn" @click="showBrnachLocation(item)">
              <i class="fal fa-eye"></i>
            </button>
          </div>
        </template>
        <template v-slot:[`item.locationDescription`]="{ item }">
          <div class="text-center">
            <button
              class="btn_eye_action"
              @click="showLocationDescDialog(item)"
              title="عرض وصف الموقع"
            >
              <i class="fal fa-eye"></i>
            </button>
          </div>
        </template>

        <!-- IsActive -->
        <!-- <template v-slot:[`item.is_active`]="{ item }">
            <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
              {{ item.is_active ? "مفعل" : "معطل" }}
            </span>
          </template> -->
        <!-- <template v-slot:[`item.fullname`]="{ item }">
            <span v-if="!item.fullname || item.fullname == ''">لا يوجد</span>
            <span>{{ item.fullname }}</span>
          </template> -->
        <!-- <template v-slot:[`item.phone`]="{ item }">
            <span v-if="!item.phone || item.phone == ''">لا يوجد</span>
            <span>{{ item.phone_code + item.phone }}</span>
          </template> -->
        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <v-icon class="edit" small @click="showItem(item)">
              fal fa-eye
            </v-icon>
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon>
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <div class="d-flex justify-content-between">
            <h3 class="table-title title">الفروع</h3>
            <button class="btn add_branch_btn" @click="$emit('addBranch')">
              <span class="ml-3"><i class="fal fa-plus"></i></span>
              <span>إضافة فرع</span>
            </button>
          </div>
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="locationDialog" width="800px">
            <v-card class="p-0">
              <div class="main_border" style="height: 500px">
                <GmapMap
                  style="width: 100%; height: 100%"
                  :zoom="10"
                  :center="{ lat: +location.lat, lng: +location.lng }"
                  ref="map"
                >
                  <GmapMarker
                    :position="{ lat: +location.lat, lng: +location.lng }"
                    :draggable="false"
                  />
                </GmapMap>
              </div>
            </v-card>
          </v-dialog>

          <!-- Location Description Dialog Modal -->
          <v-dialog
            v-model="locationDescDialog"
            width="520"
            content-class="creative_dialog_overlay"
          >
            <v-card class="p-4 p-md-5 custom_dialog_card">
              <button
                class="dialog_close_btn"
                @click="locationDescDialog = false"
                title="إغلاق"
              >
                <i class="fal fa-times"></i>
              </button>

              <div class="dialog_header text-center mb-4">
                <div class="dialog_icon_box_3d icon_primary">
                  <i class="fal fa-map-marked-alt"></i>
                  <div class="pulse_effect"></div>
                </div>
                <h4 class="dialog_title font-weight-bold mt-3 mb-1">
                  وصف موقع الفرع
                </h4>
                <span class="badge_branch_name" v-if="selectedBranchName">
                  {{ selectedBranchName }}
                </span>
              </div>

              <div class="location_desc_body p-4 mb-4">
                <p class="desc_text m-0 text-center">
                  {{ selectedLocationDesc }}
                </p>
              </div>

              <div class="d-flex justify-content-center">
                <v-btn
                  class="creative_cancel_btn px-9 font-weight-bold"
                  @click="locationDescDialog = false"
                  outlined
                  color="grey darken-1"
                >
                  إغلاق
                </v-btn>
              </div>
            </v-card>
          </v-dialog>

          <!-- Add & Delete -->
          <v-row>
            <v-col cols="12" sm="8"></v-col>
          </v-row>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>

    <div v-else class="no_branches">
      <div>لا يوجد فروع لهذا المتجر</div>
      <div class="no_branches_img"><i class="fas fa-store-alt-slash"></i></div>
      <button class="btn add_branch_btn" @click="$emit('addBranch')">
        <span class="ml-3"><i class="fal fa-plus"></i></span>
        <span>إضافة فرع</span>
      </button>
    </div>
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- <v-dialog v-model="statusModel" width="500">
      <v-card class="p-4" v-if="statusItem">
        <h5 v-if="statusItem.is_active">هو تود الغاء تفعيل هذا المتجر؟</h5>
        <h5 v-else>هو تود تفعيل هذا المتجر؟</h5>

        <textarea
          v-if="statusItem.is_active"
          v-model="deactive_reason"
          placeholder="السبب ..."
          class="deactive_reason mt-5 px-3"
        ></textarea>
        <div class="text-center mt-5">
          <v-btn
            class="ml-2 px-10"
            @click="changeStatus"
            :color="statusItem.is_active ? 'error' : 'success'"
            >نعم</v-btn
          >
          <v-btn
            class="mr-2 px-10"
            @click="statusModel = false"
            :color="statusItem.is_active ? 'success' : 'error'"
            >لا</v-btn
          >
        </div>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      location: { lat: null, lng: null },
      locationDialog: false,
      locationDescDialog: false,
      selectedLocationDesc: null,
      selectedBranchName: null,
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      itemtoDelete: null,
      statusModel: false,
      statusItem: null,
      deactive_reason: null,
      dialogDelete: false,
      branches: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "center",
          value: "index",
          sortable: true,
        },
        {
          text: "الصورة",
          align: "center",
          value: "avatar",
          sortable: false,
        },
        {
          text: "الاسم",
          value: "name",
          align: "center",
        },
        {
          text: "وصف الموقع",
          value: "locationDescription",
          align: "center",
        },

        {
          text: "عدد التفضيلات",
          value: "favorite_count",
          align: "center",
        },
        {
          text: "الموقع",
          value: "location",
          align: "center",
        },
        {
          text: "لديه وجبات ؟",
          value: "is_have_meals",
          align: "center",
        },
        {
          text: "التحكم",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    toggleStatusModel(item) {
      this.statusModel = true;
      this.statusItem = item;
    },
    changeStatus() {
      if (this.statusItem.is_active && !this.deactive_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الغاء التفعيل اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      const formData = new FormData();
      formData.append("is_active", this.statusItem.is_active ? 0 : 1);
      if (this.deactive_reason) {
        formData.append("message", this.deactive_reason);
      }
      formData.append("_method", "PUT");

      console.log(this.statusItem);
      this.$axios({
        method: "POST",
        url: `/store/is_active/${this.statusItem.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.$emit("get_store");
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    editItem(item) {
      this.$emit("editBranch", item);
    },
    showItem(item) {
      this.$emit("showBranch", item.id);
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `destroy_place/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.branches = this.branches.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    showLocationDescDialog(item) {
      this.selectedBranchName = item.name || "الفرع";
      this.selectedLocationDesc =
        item.locationDescription ||
        item.location_description ||
        item.location ||
        item.address ||
        "لا يوجد وصف لهذا الموقع";
      this.locationDescDialog = true;
    },

    showBrnachLocation(item) {
      this.location = item;
      this.locationDialog = true;
    },

    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `place/${this.$route.params.id}/branches`,
      })
        .then((res) => {
          this.loading = false;

          this.branches = res.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.setRows();
    console.log("ddddddd");
  },
};
</script>
<style lang="scss" scoped>
.store_wrapper {
  padding: 1rem;
  @include mainShadow;
  border-radius: 15px;
}
.add_branch_btn {
  color: gray;
  font-size: 1.3rem;
  display: inline-block;
  margin: 10px;
  @include mainShadow;
}
.no_branches {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.5rem;
  //   font-weight: bold;
  color: gray;
  .no_branches_img {
    font-size: 10rem;
    color: var(--mainColor-2);
  }
  .btn {
    padding-inline: 3rem;
    background: var(--mainColor-2);
    color: white;
  }
}

.btn_eye_action {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(120, 61, 115, 0.08);
  color: var(--mainColor-2, #783d73);
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    background: var(--mainColor-2, #783d73);
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(120, 61, 115, 0.25);
  }
}

.badge_branch_name {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 50px;
  background: rgba(120, 61, 115, 0.1);
  color: var(--mainColor-2, #783d73);
  margin-top: 6px;
}

.location_desc_body {
  background: #f8fafc;
  border-radius: 16px;
  border: 1px solid #f1f5f9;

  .desc_text {
    font-size: 0.95rem;
    color: #334155;
    line-height: 1.7;
    font-weight: 600;
  }
}
</style>
